import React from 'react'
import { HashLink } from 'react-router-hash-link'
import ScrollToTop from './ScrollToTop'

export default function Footer(props){
    return(
        <div id='footer-wrapper'>
            {props.back? <BackButton/>:''}
            <br/>
            {props.back? '':<p>2026.</p>}
        </div>
    )
}

function BackButton(){
    return(
        <ScrollToTop>
            <HashLink to='/hi#projects'>
                <h3>{'<'} Back</h3>
            </HashLink>
        </ScrollToTop>
    )
}